
export default {
  'SET_AUTH_TOKEN' (state, token) {
    state.token = token
  },
  'SET_SISTEMA' (state, _collapsed) {
    state.sistema.collapsed = _collapsed
  },
  'SET_FILTROS_GESTAO_JORNADA' (state, _filtros) {
    state.filtrosGestaoJornada.dataInicial = _filtros.dataInicial
    state.filtrosGestaoJornada.dataFinal = _filtros.dataFinal
    state.filtrosGestaoJornada.buscas = _filtros.buscas
    state.filtrosGestaoJornada.status = _filtros.status
    state.filtrosGestaoJornada.exibir = _filtros.exibir
    state.filtrosGestaoJornada.ordem = _filtros.ordem
  },
  'SET_FILTROS_RELATORIOS' (state, _filtros) {
    state.filtrosRelatorios.clienteId = _filtros.clienteId
    state.filtrosRelatorios.veiculoId = _filtros.veiculoId
    state.filtrosRelatorios.veiculoDescricao = _filtros.veiculoDescricao
    state.filtrosRelatorios.dataInicial = _filtros.dataInicial
    state.filtrosRelatorios.horaInicial = _filtros.horaInicial
    state.filtrosRelatorios.dataFinal = _filtros.dataFinal
    state.filtrosRelatorios.horaFinal = _filtros.horaFinal
    state.filtrosRelatorios.relatorio = _filtros.relatorio
    state.filtrosRelatorios.buscaVeiculo = _filtros.buscaVeiculo
    state.filtrosRelatorios.selecionada = _filtros.selecionada
    state.filtrosRelatorios.filtroVelocidade = _filtros.filtroVelocidade
    state.filtrosRelatorios.filtroVelocidadeMinima = _filtros.filtroVelocidadeMinima
    state.filtrosRelatorios.filtroVelocidadeMaxima = _filtros.filtroVelocidadeMaxima
    state.filtrosRelatorios.desprezarVelocidade = _filtros.desprezarVelocidade
    state.filtrosRelatorios.agruparPosicoes = _filtros.agruparPosicoes
    state.filtrosRelatorios.entrada = _filtros.entrada
    state.filtrosRelatorios.entradaVelocidade = _filtros.entradaVelocidade
    state.filtrosRelatorios.obdIgnicao = _filtros.obdIgnicao
    state.filtrosRelatorios.obdRpm = _filtros.obdRpm
    state.filtrosRelatorios.obdTemperatura = _filtros.obdTemperatura
    state.filtrosRelatorios.obdErro = _filtros.obdErro
    state.filtrosRelatorios.agrupar = _filtros.agrupar
    state.filtrosRelatorios.formato = _filtros.formato
  },
  'SET_FILTROS_CLIENTE' (state, _filtros) {
    state.filtrosCliente.buscas = _filtros.buscas
    state.filtrosCliente.pagina = _filtros.pagina
    state.filtrosCliente.quantidade = _filtros.quantidade
    state.filtrosCliente.status = _filtros.status
    state.filtrosCliente.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_FORNECEDOR' (state, _filtros) {
    state.filtrosFornecedor.buscas = _filtros.buscas
    state.filtrosFornecedor.pagina = _filtros.pagina
    state.filtrosFornecedor.quantidade = _filtros.quantidade
    state.filtrosFornecedor.status = _filtros.status
    state.filtrosFornecedor.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_TRANSPORTADOR' (state, _filtros) {
    state.filtrosTransportador.buscas = _filtros.buscas
    state.filtrosTransportador.pagina = _filtros.pagina
    state.filtrosTransportador.quantidade = _filtros.quantidade
    state.filtrosTransportador.status = _filtros.status
    state.filtrosTransportador.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_VEICULO' (state, _filtros) {
    state.filtrosVeiculo.buscas = _filtros.buscas
    state.filtrosVeiculo.pagina = _filtros.pagina
    state.filtrosVeiculo.quantidade = _filtros.quantidade
    state.filtrosVeiculo.status = _filtros.status
    state.filtrosVeiculo.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_VENDEDOR' (state, _filtros) {
    state.filtrosVendedor.buscas = _filtros.buscas
    state.filtrosVendedor.pagina = _filtros.pagina
    state.filtrosVendedor.quantidade = _filtros.quantidade
    state.filtrosVendedor.status = _filtros.status
    state.filtrosVendedor.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_PRODUTO' (state, _filtros) {
    state.filtrosProduto.buscas = _filtros.buscas
    state.filtrosProduto.pagina = _filtros.pagina
    state.filtrosProduto.quantidade = _filtros.quantidade
    state.filtrosProduto.status = _filtros.status
    state.filtrosProduto.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_SERVICO' (state, _filtros) {
    state.filtrosServico.buscas = _filtros.buscas
    state.filtrosServico.pagina = _filtros.pagina
    state.filtrosServico.quantidade = _filtros.quantidade
    state.filtrosServico.status = _filtros.status
    state.filtrosServico.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_DEPOSITO_MOVIMENTO' (state, _filtros) {
    state.filtrosDepositoMovimento.dataInicial = _filtros.dataInicial
    state.filtrosDepositoMovimento.dataFinal = _filtros.dataFinal
    state.filtrosDepositoMovimento.produtoId = _filtros.produtoId
    state.filtrosDepositoMovimento.produtoNome = _filtros.produtoNome
    state.filtrosDepositoMovimento.tipo = _filtros.tipo
    state.filtrosDepositoMovimento.depositoId = _filtros.depositoId
  },
  'SET_FILTROS_DEPOSITO_BALANCO' (state, _filtros) {
    state.filtrosDepositoBalanco.dataInicial = _filtros.dataInicial
    state.filtrosDepositoBalanco.dataFinal = _filtros.dataFinal
    state.filtrosDepositoBalanco.produtoId = _filtros.produtoId
    state.filtrosDepositoBalanco.produtoNome = _filtros.produtoNome
    state.filtrosDepositoBalanco.tipo = _filtros.tipo
    state.filtrosDepositoBalanco.depositoId = _filtros.depositoId
  },
  'SET_FILTROS_FINANCEIRO' (state, _filtros) {
    state.filtrosFinanceiro.dataInicial = _filtros.dataInicial
    state.filtrosFinanceiro.dataFinal = _filtros.dataFinal
    state.filtrosFinanceiro.busca = _filtros.busca
    state.filtrosFinanceiro.titularId = _filtros.titularId
    state.filtrosFinanceiro.titularTipo = _filtros.titularTipo
    state.filtrosFinanceiro.titularNome = _filtros.titularNome
    state.filtrosFinanceiro.titular = _filtros.titular
    state.filtrosFinanceiro.exibir = _filtros.exibir
    state.filtrosFinanceiro.ordenarPor = _filtros.ordenarPor
  },
  'SET_FILTROS_BANCO' (state, _filtros) {
    state.filtrosBanco.buscas = _filtros.buscas
    state.filtrosBanco.pagina = _filtros.pagina
    state.filtrosBanco.quantidade = _filtros.quantidade
    state.filtrosBanco.status = _filtros.status
    state.filtrosBanco.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_BANCO_MOVIMENTO' (state, _filtros) {
    state.filtrosBancoMovimento.dataInicial = _filtros.dataInicial
    state.filtrosBancoMovimento.dataFinal = _filtros.dataFinal
    state.filtrosBancoMovimento.busca = _filtros.busca
    state.filtrosBancoMovimento.bancoId = _filtros.bancoId
    state.filtrosBancoMovimento.exibir = _filtros.exibir
    state.filtrosBancoMovimento.ordenarPor = _filtros.ordenarPor
  },
  'SET_FILTROS_BANCO_BOLETO' (state, _filtros) {
    state.filtrosBancoBoleto.dataInicial = _filtros.dataInicial
    state.filtrosBancoBoleto.dataFinal = _filtros.dataFinal
    state.filtrosBancoBoleto.busca = _filtros.busca
    state.filtrosBancoBoleto.bancoId = _filtros.bancoId
    state.filtrosBancoBoleto.exibir = _filtros.exibir
    state.filtrosBancoBoleto.ordenarPor = _filtros.ordenarPor
  },
  'SET_FILTROS_CHEQUE' (state, _filtros) {
    state.filtrosCheque.dataInicial = _filtros.dataInicial
    state.filtrosCheque.dataFinal = _filtros.dataFinal
    state.filtrosCheque.busca = _filtros.busca
    state.filtrosCheque.titularId = _filtros.titularId
    state.filtrosCheque.titularTipo = _filtros.titularTipo
    state.filtrosCheque.titularNome = _filtros.titularNome
    state.filtrosCheque.titular = _filtros.titular
    state.filtrosCheque.status = _filtros.status
    state.filtrosCheque.ordenarPor = _filtros.ordenarPor
  },
  'SET_FILTROS_COMPRA' (state, _filtros) {
    state.filtrosCompra.dataInicial = _filtros.dataInicial
    state.filtrosCompra.dataFinal = _filtros.dataFinal
    state.filtrosCompra.fornecedorId = _filtros.fornecedorId
    state.filtrosCompra.fornecedorNome = _filtros.fornecedorNome
    state.filtrosCompra.numero = _filtros.numero
    state.filtrosCompra.status = _filtros.status
    state.filtrosCompra.selecionada = _filtros.selecionada
    state.filtrosCompra.selecionadaCompra = _filtros.selecionadaCompra
  },
  'SET_FILTROS_COMPRA_COTACAO' (state, _filtros) {
    state.filtrosCompraCotacao.dataInicial = _filtros.dataInicial
    state.filtrosCompraCotacao.dataFinal = _filtros.dataFinal
    state.filtrosCompraCotacao.fornecedorId = _filtros.fornecedorId
    state.filtrosCompraCotacao.fornecedorNome = _filtros.fornecedorNome
    state.filtrosCompraCotacao.numero = _filtros.numero
    state.filtrosCompraCotacao.status = _filtros.status
    state.filtrosCompraCotacao.selecionada = _filtros.selecionada
    state.filtrosCompraCotacao.selecionadaCompra = _filtros.selecionadaCompra
  },
  'SET_FILTROS_VENDA' (state, _filtros) {
    state.filtrosVenda.dataInicial = _filtros.dataInicial
    state.filtrosVenda.dataFinal = _filtros.dataFinal
    state.filtrosVenda.clienteId = _filtros.clienteId
    state.filtrosVenda.clienteNome = _filtros.clienteNome
    state.filtrosVenda.numero = _filtros.numero
    state.filtrosVenda.status = _filtros.status
  },
  'SET_FILTROS_DEVOLUCAO' (state, _filtros) {
    state.filtrosDevolucao.dataInicial = _filtros.dataInicial
    state.filtrosDevolucao.dataFinal = _filtros.dataFinal
    state.filtrosDevolucao.clienteId = _filtros.clienteId
    state.filtrosDevolucao.clienteNome = _filtros.clienteNome
    state.filtrosDevolucao.numero = _filtros.numero
    state.filtrosDevolucao.status = _filtros.status
  },
  'SET_FILTROS_VENDA_SERVICO' (state, _filtros) {
    state.filtrosVendaServico.dataInicial = _filtros.dataInicial
    state.filtrosVendaServico.dataFinal = _filtros.dataFinal
    state.filtrosVendaServico.clienteId = _filtros.clienteId
    state.filtrosVendaServico.clienteNome = _filtros.clienteNome
    state.filtrosVendaServico.numero = _filtros.numero
    state.filtrosVendaServico.status = _filtros.status
  },
  'SET_FILTROS_VENDA_COMODATO' (state, _filtros) {
    state.filtrosVendaComodato.dataInicial = _filtros.dataInicial
    state.filtrosVendaComodato.dataFinal = _filtros.dataFinal
    state.filtrosVendaComodato.clienteId = _filtros.clienteId
    state.filtrosVendaComodato.clienteNome = _filtros.clienteNome
    state.filtrosVendaComodato.numero = _filtros.numero
    state.filtrosVendaComodato.status = _filtros.status
  },
  'SET_FILTROS_NOTA_FISCAL' (state, _filtros) {
    state.filtrosNotaFiscal.dataInicial = _filtros.dataInicial
    state.filtrosNotaFiscal.dataFinal = _filtros.dataFinal
    state.filtrosNotaFiscal.clienteId = _filtros.clienteId
    state.filtrosNotaFiscal.clienteNome = _filtros.clienteNome
    state.filtrosNotaFiscal.numero = _filtros.numero
    state.filtrosNotaFiscal.status = _filtros.status
  },
  'SET_FILTROS_FORMA_PAGAMENTO' (state, _filtros) {
    state.filtrosFormaPagamento.buscas = _filtros.buscas
    state.filtrosFormaPagamento.pagina = _filtros.pagina
    state.filtrosFormaPagamento.quantidade = _filtros.quantidade
    state.filtrosFormaPagamento.status = _filtros.status
    state.filtrosFormaPagamento.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_CODIGO_NCM' (state, _filtros) {
    state.filtrosCodigoNcm.buscas = _filtros.buscas
    state.filtrosCodigoNcm.pagina = _filtros.pagina
    state.filtrosCodigoNcm.quantidade = _filtros.quantidade
    state.filtrosCodigoNcm.status = _filtros.status
    state.filtrosCodigoNcm.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_CIDADE' (state, _filtros) {
    state.filtrosCidade.buscas = _filtros.buscas
    state.filtrosCidade.pagina = _filtros.pagina
    state.filtrosCidade.quantidade = _filtros.quantidade
    state.filtrosCidade.status = _filtros.status
    state.filtrosCidade.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_MOTORISTA' (state, _filtros) {
    state.filtrosMotorista.buscas = _filtros.buscas
    state.filtrosMotorista.pagina = _filtros.pagina
    state.filtrosMotorista.quantidade = _filtros.quantidade
    state.filtrosMotorista.status = _filtros.status
    state.filtrosMotorista.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_EVENTO' (state, _filtros) {
    state.filtrosEvento.buscas = _filtros.buscas
    state.filtrosEvento.pagina = _filtros.pagina
    state.filtrosEvento.quantidade = _filtros.quantidade
    state.filtrosEvento.status = _filtros.status
    state.filtrosEvento.selecionada = _filtros.selecionada
  },
  'SET_FILTROS_EVENTO_DISPARADO' (state, _filtros) {
    state.filtrosEventoDisparado.dataInicial = _filtros.dataInicial
    state.filtrosEventoDisparado.dataFinal = _filtros.dataFinal
    state.filtrosEventoDisparado.buscas = _filtros.buscas
    state.filtrosEventoDisparado.eventoId = _filtros.eventoId
    state.filtrosEventoDisparado.status = _filtros.status
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js